import React, { useState } from 'react';
import { Page } from 'react-pdf';
import { Document } from 'react-pdf/dist/esm/entry.webpack';
import 'antd/dist/antd.css';
import { Layout, Row, Button, Space, Card } from 'antd';
import {
  CaretLeftOutlined,
  CaretRightOutlined,
} from '@ant-design/icons';
import PropTypes from 'prop-types';

/**
 * Component that returns a component that show pdf preview.
 * @component
 * @returns {Element} view with pdf preview
 */
const ShowPdf = ({ pdf }) => {

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [showSign, setShowSign] = useState(false);

  const pdfLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const pageRight = () => {
    if (!showSign) {
      setPageNumber(pageNumber + 1);
      (pageNumber >= numPages) && (setShowSign(true));
    }
  };

  const pageLeft = () => {
    setPageNumber(pageNumber - 1);
    setShowSign(false);
  };

  return (
    <Layout className="site-layout unselectable" onCopy={(e) => { e.preventDefault(); return false; }}>
      <Card>
        <Document
          file={`data:application/pdf;base64,${pdf}`}
          loading={'Loading PDF...'}
          onLoadSuccess={pdfLoadSuccess}
        >
          <Page pageNumber={pageNumber} />
        </Document>
        <Row className="justify-content-center">
          <Space>
            <Button
              type="primary"
              shape="circle"
              icon={<CaretLeftOutlined />}
              size={'small'}
              onClick={() => { pageLeft(); }}
              disabled={(pageNumber <= 1) ? true : false}
            />
            <p> Página {pageNumber} de {numPages} </p>
            <Button
              type="primary"
              shape="circle"
              icon={<CaretRightOutlined />}
              size={'small'}
              onClick={() => { pageRight(); }}
              disabled={(pageNumber >= numPages) ? true : false}
            />
          </Space>
        </Row>
      </Card>
    </Layout>
  );
};

ShowPdf.propTypes = {
  pdf: PropTypes.string.isRequired,
};

export default ShowPdf;